import Handler from "@/core/domain/usecase/handler"

const createConfirmImageUploadRepository = (axios) => async (data) => {
    try {
        const response = await axios.post(`/confirm-image-upload`, data)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default createConfirmImageUploadRepository